function initAccordion(sectionId) {
  const accordionTriggers = document.querySelectorAll(
    `${sectionId} .js-accordion-trigger`
  );

  accordionTriggers.forEach((trigger) => {
    const icon = trigger
      .closest(`${sectionId} .Unit203_FAQs__item`)
      .querySelector(`${sectionId} span.Unit203_Accordion__icon`);
    const target = document.getElementById(
      trigger.getAttribute("aria-controls")
    );

    target.style.height = "0px";
    target.style.overflow = "hidden";
    target.style.transition = "height 0.3s ease";

    trigger.addEventListener("click", function () {
      const expanded = this.getAttribute("aria-expanded") === "true";
      const showOne = this.getAttribute("data-show-one") === "true";

      if (showOne) {
        accordionTriggers.forEach((otherTrigger) => {
          if (otherTrigger !== trigger) {
            otherTrigger.setAttribute("aria-expanded", "false");
            const otherTarget = document.getElementById(
              otherTrigger.getAttribute("aria-controls")
            );

            otherTarget.style.height = "0px";
            otherTrigger
              .closest(`${sectionId} .Unit203_FAQs__item`)
              .querySelector(`${sectionId} span.Unit203_Accordion__icon`)
              .classList.remove("opened");
          }
        });
      }

      this.setAttribute("aria-expanded", String(!expanded));

      if (!expanded) {
        target.style.display = "block";
        const scrollHeight = target.scrollHeight;
        target.style.height = scrollHeight + "px";
      } else {
        target.style.height = "0px";
        target.addEventListener(
          "transitionend",
          () => {
            target.style.display = "none";
          },
          { once: true }
        );
      }

      icon.classList.toggle("opened");
    });

    icon.addEventListener("click", function (event) {
      event.stopPropagation();
      trigger.click();
    });
  });
}
